<template>
  <thead>
    <tr>
      <th
        v-for="(column, index) in props.columns"
        :key="index"
        :class="[{header: props.sortable === true}, 'table-hover-bg']"
        @click="handleSort(column)"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>{{ column }}</span>
          <Icon
            v-if="sortable && sortKey === column"
            :icon="
              sortDirection === 1
                ? 'material-symbols:arrow-downward'
                : 'material-symbols:arrow-upward'
            "
            class="float-end"
          />
        </div>
      </th>
    </tr>
  </thead>
</template>

<script lang="ts" setup>
const emits = defineEmits(['sort']);

type Props = {
  columns: string[];
  sortable?: boolean;
  sortKey: string | null;
  sortDirection?: number;
};
const props = withDefaults(defineProps<Props>(), {
  sortable: false,
  sortKey: null,
  sortDirection: 1,
});

const handleSort = (column: string) => {
  if (props.sortable) {
    emits('sort', column);
  }
};
</script>

<style lang="scss" scoped>
.header {
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.table-hover-bg {
  // Same value used for table row hover
  background-color: rgb(var(--bs-emphasis-color-rgb), 0.075);
}
</style>
